module.exports = __webpack_public_path__ + "img/scrmT2.bfbd1bdb.png";